/* ========================================================================= */
/* Google Maps key */
/* ========================================================================= */

let GOOGLE_MAPS_KEY = null;

/**
 * Set global variable GOOGLE_MAPS_KEY
 * @param {string} ua Google Maps key
 */
export const setGoogleMapsKey = (ua) => {
    GOOGLE_MAPS_KEY = ua;
};

/**
 * Get global variable GOOGLE_MAPS_KEY
 * @return {string}
 */
export default () => {
    return GOOGLE_MAPS_KEY;
};
